import React, { useEffect, useState } from 'react'
import {
  Btn,
  CustomDataTableHeader,
  CustomModal,
  InputNumeroDecimal,
} from '../../../../../components'
import { errorHandler } from '../../../../../services/util/error.service'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'

export default function ModalCicloAlteracaoQuantidade({ visible, deliveryItems, onResponse }) {
  const [items, setItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    if (visible && Array.isArray(deliveryItems)) {
      setItems(deliveryItems)
    }
  }, [visible])

  // Events
  const onBtnClick = async () => {
    try {
      setIsLoading(true)
      const itemsModificados = items.filter(i => {
        const qteCaixaNova = Number(i.qte_sku_nova)
        const ehNumero = !Number.isNaN(qteCaixaNova)

        if (ehNumero) {
          const ehMaiorQueZero = qteCaixaNova > 0
          const ehDifQteAtual = qteCaixaNova !== i.qte_total
          const ehDifDoAtual = qteCaixaNova !== Number(i.qte_total)
          return ehMaiorQueZero && ehDifQteAtual && ehDifDoAtual
        }
        return false
      })

      if (itemsModificados.length) {
        await CicloEntregaAcoesHttp.updateDeliveriesItems(itemsModificados)
      }

      onResponse('success')
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  const onInputTextQteNovaChange = (value, item) => {
    setItems(prev => {
      const index = prev.findIndex(i => i.id === item.id)
      if (index !== -1) {
        prev[index].qte_sku_nova = value
      }
      return [...prev]
    })
  }

  // Render
  return (
    <CustomModal
      isVisible={visible}
      header={'Produtos'}
      onClose={() => onResponse('close')}
      width={800}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <Btn onClick={onBtnClick} isLoading={isLoading}>
            Salvar
          </Btn>
        </div>
        <div className="p-col-12">
          <DataTable
            className="p-datatable-sm"
            value={items}
            rows={10}
            paginator={true}
            globalFilter={globalFilter}
            header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
          >
            <Column field={'product_code'} header={'Código'} style={tableCellCentered(120)} />

            <Column field={'product_name'} header={'Produto'} />
            <Column field={'qte_total'} header={'Qte. Original'} style={tableCellCentered()} />
            <Column
              header={'Qte. Alterada'}
              style={tableCellCentered()}
              body={item => (
                <InputNumeroDecimal
                  marginTop={0}
                  value={item.qte_sku_nova ? item.qte_sku_nova : ''}
                  onChange={value => onInputTextQteNovaChange(value, item)}
                />
              )}
            />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}
